<section class="relation-settings">
  <div class="relation-heading"><mat-icon>account_tree</mat-icon><h3>{{ config.title || 'Relations' }}</h3><span *ngIf="added.length" class="relation-count">{{ added.length }}</span></div>
  <p class="relation-hint" *ngIf="config.hint">{{ config.hint }}</p>
  <div class="relation-field" *ngFor="let field of config.dropdowns">
    <label [for]="'relation-' + field.id">{{ field.label }}</label>
    <ng-select class="ss-select" [labelForId]="'relation-' + field.id" appendTo="body"
      [items]="options[field.id] || []" bindLabel="label" bindValue="value"
      [placeholder]="field.placeholder || 'Select ' + field.label" [clearable]="true"
      [loading]="!!loading[field.id]" [disabled]="!dependenciesReady(field) || !!loading[field.id]"
      [ngModel]="selections[field.id]" (ngModelChange)="select(field, $event)">
    </ng-select>
    <div class="relation-error" *ngIf="optionErrors[field.id]" role="alert">
      {{ optionErrors[field.id] }} <button type="button" mat-button (click)="loadOptions(field)">Retry</button>
    </div>
  </div>
  <div class="relation-actions"><button type="button" mat-stroked-button [disabled]="!canAdd" (click)="add()"><mat-icon>add</mat-icon>Add</button></div>
  <div class="relation-list" *ngIf="added.length">
    <div class="relation-list-title">Added relations <span>{{ added.length }}</span></div>
    <div class="relation-card" *ngFor="let hop of added; let i = index">
      <span class="relation-index">{{ i + 1 }}</span>
      <div class="relation-details"><strong>{{ labelFor(hop) }}</strong><span class="relation-route">{{ hop.searchAttribute }} <mat-icon>arrow_forward</mat-icon> {{ hop.extractAttribute }}</span><span class="relation-entity">{{ hop.targetEntity }}</span></div>
      <div class="relation-card-actions">
        <button type="button" mat-icon-button [disabled]="i === 0" (click)="move(i, -1)" matTooltip="Move earlier" aria-label="Move relation earlier"><mat-icon>keyboard_arrow_up</mat-icon></button>
        <button type="button" mat-icon-button [disabled]="i === added.length - 1" (click)="move(i, 1)" matTooltip="Move later" aria-label="Move relation later"><mat-icon>keyboard_arrow_down</mat-icon></button>
        <button type="button" mat-icon-button class="relation-remove" (click)="remove(i)" matTooltip="Remove relation" aria-label="Remove relation"><mat-icon>close</mat-icon></button>
      </div>
    </div>
  </div>
  <p class="relation-notice" aria-live="polite">{{ notice }}</p>
</section>
